import InnerPageLayout from "../../components/feature/InnerPageLayout";

const sections = [
  {
    title: "1. 개인정보처리방침 개요",
    content: `주식회사 툴뮤직(이하 "회사")는 「개인정보 보호법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 관련 법령을 준수하며, 이용자의 개인정보를 안전하게 처리합니다. 이 방침은 회사가 수집하는 개인정보의 항목, 수집 목적, 보유 기간 및 이용자의 권리에 대해 안내합니다.`,
  },
  {
    title: "2. 수집하는 개인정보 항목",
    content: `회사는 서비스 이용을 위해 다음과 같은 개인정보를 수집합니다.\n\n[필수 수집 항목]\n· 이메일 주소\n· 성명\n· 연락처 (전화번호)\n\n[선택 수집 항목]\n· 소속 기관명, 직책\n· 포트폴리오 URL 또는 SNS 채널 정보\n· 팔로워 수 등 채널 현황 정보\n\n[자동 수집 정보]\n· IP 주소, 쿠키, 방문 일시, 브라우저 종류, 서비스 이용 기록`,
  },
  {
    title: "3. 개인정보의 수집 및 이용 목적",
    content: `수집한 개인정보는 다음 목적에만 활용됩니다.\n\n① 서비스 제공 및 계약 이행: 빌딩 플랜 진단, 파트너 매칭, 서비스 신청 처리\n② 고객 지원: 문의·불만 처리, 공지사항 전달\n③ 마케팅 및 뉴스레터 발송: 크리에이터 비즈니스 인사이트 제공 (수신 동의자에 한함)\n④ 서비스 개선 및 통계 분석: 방문 패턴 분석, 서비스 품질 향상`,
  },
  {
    title: "4. 개인정보의 보유 및 이용 기간",
    content: `회사는 이용자의 개인정보를 목적 달성 후 즉시 파기합니다. 단, 관련 법령에 의한 보존 의무가 있는 경우 해당 기간 동안 보관합니다.\n\n· 계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래법)\n· 대금 결제 및 재화 공급에 관한 기록: 5년 (전자상거래법)\n· 소비자 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래법)\n· 접속에 관한 기록: 3개월 (통신비밀보호법)`,
  },
  {
    title: "5. 개인정보의 제3자 제공",
    content: `회사는 이용자의 동의 없이 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우는 예외입니다.\n\n① 이용자가 사전에 동의한 경우\n② 법령의 규정에 의한 경우 (수사기관의 적법한 요구 등)\n③ 서비스 제공을 위한 수탁업체에 위탁하는 경우 (결제 처리, 이메일 발송 서비스 등)`,
  },
  {
    title: "6. 이용자의 권리",
    content: `이용자는 언제든지 다음의 권리를 행사할 수 있습니다.\n\n① 개인정보 처리 현황 조회 및 열람 요청\n② 개인정보 오류 정정 또는 삭제 요청\n③ 개인정보 처리 정지 요청\n④ 뉴스레터 수신 동의 철회\n\n권리 행사 방법: eunhyun1@naver.com 으로 이메일 문의`,
  },
  {
    title: "7. 개인정보의 안전한 관리",
    content: `회사는 개인정보의 안전한 관리를 위해 다음과 같은 조치를 취합니다.\n\n· 개인정보에 대한 접근 권한 최소화\n· 비밀번호 암호화 저장\n· SSL 암호화 전송\n· 개인정보 처리 직원 최소화 및 정기 교육\n· 개인정보 처리 시스템 접근 로그 관리`,
  },
  {
    title: "8. 개인정보 처리방침 변경",
    content: `이 방침은 2026년 3월 26일부터 시행됩니다. 내용 추가, 삭제 및 수정이 있을 경우 개정 7일 전에 서비스 내 공지를 통해 안내하겠습니다.\n\n개인정보 보호 담당자: 정은현\n연락처: eunhyun1@naver.com`,
  },
];

export default function PrivacyPage() {
  return (
    <InnerPageLayout>
      <section className="py-24 lg:py-36 px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="mb-12 lg:mb-16">
            <span className="inline-block text-xs font-display font-medium tracking-widest uppercase text-brand-teal mb-5 px-3 py-1 rounded-full border border-brand-teal/30 bg-brand-teal/5">
              Legal
            </span>
            <h1 className="font-display text-3xl md:text-5xl font-bold text-white leading-snug">개인정보처리방침</h1>
            <p className="mt-5 text-white/40 font-body text-sm leading-relaxed">시행일: 2026년 3월 26일 · 최종 수정: 2026년 3월 26일</p>
          </div>

          <div className="flex flex-col gap-10 lg:gap-14">
            {sections.map((sec) => (
              <div key={sec.title} className="glass rounded-2xl p-6 lg:p-9 flex flex-col gap-5">
                <h2 className="font-display text-lg font-bold text-white">{sec.title}</h2>
                <p className="text-white/60 text-sm font-body leading-loose whitespace-pre-line">{sec.content}</p>
              </div>
            ))}
          </div>

          <div className="mt-12 lg:mt-16 text-center">
            <p className="text-white/30 text-xs font-body">개인정보 관련 문의: <a href="mailto:eunhyun1@naver.com" className="text-brand-teal hover:text-brand-teal-bright cursor-pointer transition-colors">eunhyun1@naver.com</a></p>
          </div>
        </div>
      </section>
    </InnerPageLayout>
  );
}
